import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20display%20with%20neatly%20arranged%20sneakers%20on%20wooden%20shelves%2C%20warm%20amber%20ambient%20lighting%20from%20overhead%20track%20lights%2C%20modern%20boutique%20interior%20with%20exposed%20brick%20wall%20and%20polished%20concrete%20floor%2C%20carefully%20curated%20streetwear%20collection%20featuring%20premium%20sneakers%20and%20folded%20denim%2C%20editorial%20retail%20photography%20with%20dramatic%20shadows%20and%20rich%20warm%20tones%2C%20luxury%20shopping%20atmosphere%20with%20inviting%20depth%20and%20texture&width=1600&height=1000&seq=hero-v2-fashion-lifestyle&orientation=landscape"
          alt="Superbuy Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-10 pt-20 md:pt-28">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="flex-1 pt-8 md:pt-16">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1]">
              Superbuy Spreadsheet<br />
              <span className="font-normal italic text-white/80">The Ultimate Resource</span><br />
              <span className="text-white/90">For Smarter Shopping</span>
            </h1>
            <p className="mt-6 text-white/70 text-sm md:text-base max-w-lg leading-relaxed">
              Superbuy Spreadsheet helps users organize product information, compare prices, manage shopping data, and create a smarter purchasing workflow. Everything you need to make informed buying decisions in one place.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                Superbuy Sheet
                <span className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-full border-2 border-white/30 text-white text-sm font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
            <p className="mt-6 text-white/50 text-xs flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line"></i>
              </span>
              Trusted Resource For Superbuy Spreadsheet Users
            </p>
          </div>
          <div className="flex-1 hidden lg:flex items-center justify-center pt-16">
            <div className="relative">
              <Link
                to="/superbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm font-medium hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-book-open-line"></i>
                </span>
                Read Complete Guide
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}